import { AsyncContainer } from 'badphraim/core/AsyncContainer';
import { GenericReduxSubStoreBase } from 'badphraim/ui/GenericReduxSubStoreBase';
export class BoostPortalSubStore extends GenericReduxSubStoreBase {
    /** @override */ getRootStore() {
        return BoostPortalSubStore.rootstore.getValue();
    }
}
BoostPortalSubStore.rootstore = new AsyncContainer();
